<script>
// Components
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config.json";

// Services
import FinancialsService from "@/services/FinancialsStatsDataService";

// Helpers

export default {
  name: "financials",
  page: {
    localePicker: () => import(`vue2-datepicker/locale/${this.$i18n.locale}`),
    title: "Dashboard Financial",
    meta: [
      {
        name: "description",
        content: appConfig.description
      },
    ],
  },
  components: {
    Layout,
    PageHeader
  },
  methods: {
    loadStats() {
      FinancialsService
        .getTodayStats()
        .then(response => {
          const {stats} = response.data;
          this.stats = stats;
        })
        .catch (error => {
          window.console.error(error);
        })
    }
  },
  created() {
    this.loadStats();
  },
  data() {
    return {
      title: this.$t("menuitems.dashboards.financial"),
      stats: {
        todayPayments: '-',
        todaySubscriptions: '-',
        totalSubscriptions: '-',
        todayRevenue: '-',
        todayRevenueHT: '-',
        todayFirst: '-',
        todayRevenueFirst: '-',
        todayRenew: '-',
        todayRevenueRenew: '-',
        todayError: '-',
        todayRenewError: '-',
        renewPerformance: '-'
      }
    }
  }
}
</script>

<template>
  <Layout>
    <PageHeader :title="title" />
    <!-- Stats Text -->
    <div class="row">
      <!-- Subscriptions -->
      <div class="col-lg-2">
        <div class="card mini-stats-wid">
          <div class="card-body">
            <div class="d-flex flex-wrap">
              <div class="me-3">
                <p class="text-muted mb-2">Subscriptions</p>
                <h5 class="mb-0">{{ stats.todaySubscriptions }}
                  <span class="text-muted">( {{ stats.totalSubscriptions }} )</span>
                </h5>
              </div>

              <div class="avatar-sm ms-auto">
                <div
                    class="avatar-title bg-dark rounded-circle white font-size-20"
                >
                  <i class="bx bxs-package"></i>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- Payments -->
      <div class="col-lg-2">
        <div class="card blog-stats-wid ">
          <div class="card-body">
            <div class="d-flex flex-wrap">
              <div class="me-3">
                <p class="text-muted mb-2">Payments</p>
                <h5 class="mb-0">{{ stats.todayPayments }}
                  <span class="text-muted"> {{ stats.todayRevenue }}€ <small>({{ stats.todayRevenueHT}}€ HT)</small> </span>
                </h5>
              </div>

              <div class="avatar-sm ms-auto">
                <div
                    class="avatar-title bg-dark text-white rounded-circle font-size-20"
                >
                  <i class="bx bxs-dollar-circle"></i>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- First -->
      <div class="col-lg-2">
        <div class="card blog-stats-wid">
          <div class="card-body">
            <div class="d-flex flex-wrap">
              <div class="me-3">
                <p class="text-muted mb-2">Transactions</p>
                <h5 class="mb-0">{{ stats.todayFirst }} <small>{{ stats.todayRevenueFirst }}€</small></h5>
              </div>

              <div class="avatar-sm ms-auto">
                <div
                    class="avatar-title bg-success rounded-circle font-size-20"
                >
                  <i class="bx bxs-dollar-circle"></i>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- Renew -->
      <div class="col-lg-2">
        <div class="card blog-stats-wid">
          <div class="card-body">
            <div class="d-flex flex-wrap">
              <div class="me-3">
                <p class="text-muted mb-2">Renew</p>
                <h5 class="mb-0">{{ stats.todayRenew }} <small>{{ stats.todayRevenueRenew }}€</small></h5>
              </div>

              <div class="avatar-sm ms-auto">
                <div
                    class="avatar-title bg-info rounded-circle font-size-20"
                >
                  <i class="bx bxs-dollar-circle"></i>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- Error -->
      <div class="col-lg-2">
        <div class="card blog-stats-wid">
          <div class="card-body">
            <div class="d-flex flex-wrap">
              <div class="me-3">
                <p class="text-muted mb-2">Errors</p>
                <h5 class="mb-0">{{ stats.todayError }} <small>RENEW: {{ stats.todayRenewError}}</small></h5>
              </div>

              <div class="avatar-sm ms-auto">
                <div
                    class="avatar-title bg-danger rounded-circle  font-size-20"
                >
                  <i class="bx bxs-error"></i>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- Performance -->
      <div class="col-lg-2">
        <div class="card blog-stats-wid">
          <div class="card-body">
            <div class="d-flex flex-wrap">
              <div class="me-3">
                <p class="text-muted mb-2">Renew Perf</p>
                <h5 class="mb-0">{{ stats.renewPerformance }}%</h5>
              </div>

              <div class="avatar-sm ms-auto">
                <div
                    class="avatar-title bg-dark rounded-circle font-size-20"
                >
                  <i class="bx bxs-analyse"></i>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<style scoped>

</style>